import axios from "axios";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../constants/configuration";
import { updateRedux } from "./commonReducer";
import axiosInstance from "../utils/axiosInterceptor";

export function successToast(msg) {
  toast.success(msg, {
    position: "bottom-center",
    autoClose: 3000,
  });
}
export function errorToast(msg) {
  toast.error(msg, {
    position: "bottom-center",
    autoClose: 3000,
  });
}

export const manualLogin = async (data) => {
  let res = await axios.post(`${API_BASE_URL}auth/validateManualLogin`, data);
  return res;
};

export const googleLogin = async (data) => {
  console.log(data, "token");
  let res = await axios.post(`${API_BASE_URL}auth/validateGoogleLogin`, data);
  return res;
};

export const getmyip = async (data) => {
  let res = await axios.get(`https://api.ipify.org?format=json`);
  return res.data;
};

export const login = (data, callback) => (dispatch) => {
  dispatch(updateRedux({ key: "login_loading", value: true }));
  axios
    .post(`${API_BASE_URL}v1/admin/login`, data)
    .then((res) => {
      dispatch(updateRedux({ key: "login_loading", value: false }));
      if (res.data.status) {
        const data = res.data.data;
        localStorage.setItem("token", res.data.accessToken);
        localStorage.setItem("email", data.email);
        localStorage.setItem("role", data.role);
        if (callback) {
          callback(res.data.status);
        }
      } else {
        toast.error("Please check your username or password", {
          position: "bottom-center",
          autoClose: 3000,
        });
        if (callback) {
          callback(res.data.status);
        }
      }
    })
    .catch((err) => {
      dispatch(updateRedux({ key: "login_loading", value: false }));
      console.log(err);
    });
};

export const getAllEmployees = () => (dispatch) => {
  axiosInstance
    .get(`${API_BASE_URL}v1/employees`)
    .then((res) => {
      if (res.data.status) {
        dispatch(updateRedux({ key: "all_employees", value: res.data.data }));
      }
    })
    .catch((err) => {});
};

export const getProjects = (data) => (dispatch) => {
  dispatch(updateRedux({ key: "project_loading", value: true }));
  axiosInstance
    .post(`${API_BASE_URL}v1/projects`, data)
    .then((res) => {
      dispatch(updateRedux({ key: "project_loading", value: false }));
      if (res.data.status) {
        dispatch(updateRedux({ key: "project_data", value: res.data.data }));
        dispatch(
          updateRedux({ key: "project_page_details", value: res.data.page })
        );
      } else {
        toast.error(res.data.message, {
          position: "bottom-center",
          autoClose: 3000,
        });
      }
    })
    .catch((err) => {
      dispatch(updateRedux({ key: "project_loading", value: false }));
    });
};

export const addProjects = (data, callback) => (dispatch) => {
  dispatch(updateRedux({ key: "add_project_loading", value: true }));
  axiosInstance
    .post(`${API_BASE_URL}admin/addProject`, data)
    .then((res) => {
      dispatch(updateRedux({ key: "add_project_loading", value: false }));
      if (res.data.status == true) {
        toast.success(res.data.message, {
          position: "bottom-center",
          autoClose: 3000,
        });
        if (callback) {
          callback(res.data.status);
        }
      } else {
        toast.error(res.data.message, {
          position: "bottom-center",
          autoClose: 3000,
        });
      }
    })
    .catch((err) => {
      dispatch(updateRedux({ key: "add_project_loading", value: false }));
    });
};

export const updateProjects = (data, callback) => (dispatch) => {
  dispatch(updateRedux({ key: "add_project_loading", value: true }));
  axiosInstance
    .post(`${API_BASE_URL}admin/updateProject`, data)
    .then((res) => {
      dispatch(updateRedux({ key: "add_project_loading", value: false }));
      if (res.data.status == true) {
        toast.success(res.data.message, {
          position: "bottom-center",
          autoClose: 3000,
        });
        if (callback) {
          callback(res.data.status);
        }
      } else {
        toast.error(res.data.message, {
          position: "bottom-center",
          autoClose: 3000,
        });
      }
    })
    .catch((err) => {
      dispatch(updateRedux({ key: "add_project_loading", value: false }));
    });
};
